"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalImpression = void 0;
const investor_type_enum_1 = require("../../@types/incoming/enum/investor-type.enum");
const asset_enum_1 = require("../../@types/config/asset.enum");
const historical_forex_impression_data_1 = require("./data/historical-impressions/historical-forex-impression.data");
const historical_daytrader_impressions_1 = require("./data/historical-impressions/historical-daytrader-impressions");
const historical_swingtrader_impressions_1 = require("./data/historical-impressions/historical-swingtrader-impressions");
const historical_holder_impressions_1 = require("./data/historical-impressions/historical-holder-impressions");
const price_accumulation_data_1 = require("./data/price-accumulation.data");
const lodash_1 = require("lodash");
const historical_price_closer_impressions_data_1 = require("./data/historical-impressions/historical-price-closer-impressions.data");
const general_utils_1 = require("../utils/general.utils");
class HistoricalImpression {
    constructor(investorType, assetType) {
        this.investorType = investorType;
        this.assetType = assetType;
    }
    getAll(historicalData) {
        const lastPrice = historicalData.Last.Price;
        const lastVol = historicalData.Last.Vol;
        const summaryHigh = historicalData.Summary.High;
        const summaryVar = historicalData.Summary.Var;
        const summaryLow = historicalData.Summary.Low;
        const priceImpressions = this.getPriceImpressions(lastPrice, summaryHigh, summaryLow);
        const variationImpressions = this.getVariationImpressions(summaryVar);
        const priceCloserImpressions = this.getPriceCloserImpressions(lastPrice, summaryHigh, summaryLow);
        const volumeImpressions = this.getVolumeImpressions(lastVol);
        const unfilteredResults = [
            ...priceImpressions,
            ...variationImpressions,
            ...priceCloserImpressions,
            ...volumeImpressions,
        ].filter((impression) => impression);
        return general_utils_1.GeneralUtils.clearSimilarImpressions([
            {
                similars: ['RESISTENCIA_ATINGIDA', 'PERTO_RESISTENCIA'],
                keepOnly: 'RESISTENCIA_ATINGIDA',
            },
            {
                similars: ['SUPORTE_ATINGIDO', 'PERTO_SUPORTE'],
                keepOnly: 'SUPORTE_ATINGIDO',
            },
        ], unfilteredResults);
    }
    getVolumeImpressions(lastVol) {
        const impressions = [];
        if (lastVol && lastVol.length === 4 && this.assetType === 1) {
            const lastVolInt = parseInt(lastVol.replace(/\D/g, ''), 10);
            if (lastVolInt > 9000) {
                impressions.push(this.getGenericImpressionById(20));
            }
            else if (lastVolInt > 3500) {
                impressions.push(this.getGenericImpressionById(19));
            }
            else if (lastVolInt < 1000) {
                impressions.push(this.getGenericImpressionById(21));
            }
        }
        return impressions;
    }
    getPriceCloserImpressions(lastPrice, summaryHigh, summaryLow) {
        const impressions = [];
        const priceBaseCalc = this.getPriceBaseCalc(lastPrice);
        if (lastPrice + priceBaseCalc > summaryHigh) {
            if (this.assetType === asset_enum_1.eAssetType.FOREX) {
                impressions.push(this.getForexImpressionById(4));
            }
            else {
                impressions.push(this.getPriceCloserImpressionById(0));
            }
        }
        else if (summaryLow + priceBaseCalc > lastPrice) {
            if (this.assetType === asset_enum_1.eAssetType.FOREX) {
                impressions.push(this.getForexImpressionById(5));
            }
            else {
                impressions.push(this.getPriceCloserImpressionById(1));
            }
        }
        return impressions;
    }
    getPriceImpressions(lastPrice, summaryHigh, summaryLow) {
        const impressions = [];
        if (lastPrice >= summaryHigh) {
            if (this.assetType === asset_enum_1.eAssetType.FOREX) {
                impressions.push(this.getForexImpressionById(0));
            }
            else {
                impressions.push(this.getGenericImpressionById(0));
            }
        }
        else if (lastPrice <= summaryLow) {
            if (this.assetType === asset_enum_1.eAssetType.FOREX) {
                impressions.push(this.getForexImpressionById(1));
            }
            else {
                impressions.push(this.getGenericImpressionById(1));
            }
        }
        return impressions;
    }
    getVariationImpressions(summaryVar) {
        const impressions = [];
        const variationProfile = this.getVariationProfile();
        if (summaryVar.toString().length > 5) {
            return [];
        }
        if (summaryVar > 0) {
            const positiveImpressions = variationProfile.positiveVariations.map((variation) => {
                if (summaryVar >= variation.variation) {
                    return this.getGenericImpressionById(variation.impressionNumber);
                }
            });
            if (!(0, lodash_1.isEmpty)(positiveImpressions)) {
                const filteredPosImpressions = positiveImpressions.filter((imp) => imp);
                impressions.push(filteredPosImpressions[0]);
            }
        }
        else {
            const negativeImpressions = variationProfile.negativeVariations.map((item) => {
                if (summaryVar <= item.variation) {
                    return this.getGenericImpressionById(item.impressionNumber);
                }
            });
            if (!(0, lodash_1.isEmpty)(negativeImpressions)) {
                const filteredNegImpressions = negativeImpressions.filter((imp) => imp);
                impressions.push(filteredNegImpressions[0]);
            }
        }
        return impressions;
    }
    getPriceBaseCalc(lastPrice) {
        switch (this.assetType) {
            case asset_enum_1.eAssetType.STOCK:
                return lastPrice / 70;
            case asset_enum_1.eAssetType.FOREX:
                return lastPrice / 100;
            case asset_enum_1.eAssetType.CRYPTO:
                return lastPrice / 100;
        }
    }
    getVariationProfile() {
        switch (this.investorType) {
            case investor_type_enum_1.eInvestorType.DAY_TRADER:
                return price_accumulation_data_1.priceVariationImpressionList.dayTrader;
            case investor_type_enum_1.eInvestorType.SWING_TRADER:
                return price_accumulation_data_1.priceVariationImpressionList.swingTrader;
            case investor_type_enum_1.eInvestorType.BUY_AND_HOLDER:
                return price_accumulation_data_1.priceVariationImpressionList.holder;
        }
    }
    getGenericImpressionById(id) {
        const availableLists = [
            {
                investorType: investor_type_enum_1.eInvestorType.DAY_TRADER,
                list: historical_daytrader_impressions_1.historicalDayTraderImpressionList,
            },
            {
                investorType: investor_type_enum_1.eInvestorType.SWING_TRADER,
                list: historical_swingtrader_impressions_1.historicalSwingTraderImpressionsList,
            },
            {
                investorType: investor_type_enum_1.eInvestorType.BUY_AND_HOLDER,
                list: historical_holder_impressions_1.historicalHolderImpressionsList,
            },
        ];
        const specificList = availableLists.find((item) => item.investorType === this.investorType);
        return specificList && specificList.list.find((item) => item.id === id);
    }
    getForexImpressionById(id) {
        return historical_forex_impression_data_1.historicalForexImpressionsList.find((item) => item.id === id);
    }
    getPriceCloserImpressionById(id) {
        return historical_price_closer_impressions_data_1.HistoricalPriceCloserImpressionsList.find((item) => item.id === id);
    }
}
exports.HistoricalImpression = HistoricalImpression;
//# sourceMappingURL=historical.impression.js.map